import React, { useState } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { Button } from "../Button";
import { InputList } from "../InputList";
import { InputTextArea } from "../InputTextArea";
import { toast } from "react-toastify";
import * as API from "../../api";

export const ModalConfirmacionFirma = ({
  type,
  title,
  labelConfirm,
  lists,
  confirm,
  cancel,
}) => {
  const [listsProps, setListsProps] = useState(lists);
  const [comment, setComment] = useState("");

  const handleListChange = (field, value) => {
    const tmpListsProps = { ...listsProps };
    tmpListsProps[field.list].value = value;
    if (lists[field.list]?.listasHijas.length === 0)
      setListsProps(tmpListsProps);
    else
      lists[field.list].listasHijas.forEach((list) => {
        const listaRelacional = {
          nombreLista: field.list,
          idEntidadRelacional: value,
        };
        const data = {
          lista: list,
          listaRelacional,
        };
        API.obtenerLista(data).then((res) => {
          tmpListsProps[list].valores = res.valores;
          setListsProps(tmpListsProps);
        });
      });
  };

  const confirmMotivoCambioFechaPrevista = () => {
    const data = {};
    data.observacionesMotivoCambio = comment;
    if (listsProps.LlegadaDeApoderado?.value) {
      data.llegadaDeApoderado = !!+listsProps.LlegadaDeApoderado?.value;
    }
    data.tipoAplazamiento = listsProps.TipoAplazamiento?.value;

    if (data.llegadaDeApoderado !== undefined && data.tipoAplazamiento) {
      confirm(data);
    } else if (!data.tipoAplazamiento) {
      toast.error("Especifique el tipo de motivo de aplazamiento");
    } else if (data.llegadaDeApoderado === undefined) {
      toast.error("Especifique si ha llegado el apoderado");
    } else if (data.observacionesMotivoCambio === "") {
      toast.error("Especifique las observaciones del cambio");
    }
  };

  const convertOptions = (options) =>
    options.map((opt) => ({
      value: opt.valor,
      label: opt.etiqueta,
    }));

  const body = () => {
    switch (type) {
      case "solicitarTipoFiscalidad":
        return (
          <S.WrapperModalBody columns={1}>
            <h3>¿Desea solicitar un cambio de fiscalidad?</h3>
          </S.WrapperModalBody>
        );

      case "solicitarMotivoCambioFechaFirma":
        return (
          <S.WrapperModalBody columns={1}>
            <h3>Especifique el motivo del cambio de fecha prevista</h3>

            <InputList
              field={{
                label: "Motivo Principal*",
                name: "grupoTipoAplazamiento",
                list: "GrupoTipoAplazamiento",
              }}
              value={listsProps.GrupoTipoAplazamiento?.value || ""}
              options={
                convertOptions(listsProps.GrupoTipoAplazamiento?.valores) || []
              }
              handleChange={handleListChange}
              isClearable={false}
            />
            <InputList
              field={{
                label: "Submotivo Aplazamiento*",
                name: "tipoAplazamiento",
                list: "TipoAplazamiento",
              }}
              value={listsProps.TipoAplazamiento?.value || ""}
              options={
                convertOptions(listsProps.TipoAplazamiento?.valores) || []
              }
              handleChange={handleListChange}
              isClearable={false}
            />
            <InputList
              field={{
                label: "Llegada de apoderado*",
                name: "tipoDocumento",
                list: "LlegadaDeApoderado",
              }}
              value={listsProps.LlegadaDeApoderado?.value || null}
              options={
                convertOptions(listsProps.LlegadaDeApoderado?.valores) || []
              }
              handleChange={handleListChange}
              isClearable={false}
            />
            <InputTextArea
              field={{ name: "", label: "Observaciones*" }}
              value={comment}
              handleChange={(_name, value) => setComment(value)}
            />
          </S.WrapperModalBody>
        );
      default:
        return <p>Unknown type</p>;
    }
  };

  const buttons = () => {
    switch (type) {
      case "solicitarTipoFiscalidad":
        return (
          <>
            <Button label={labelConfirm} onClick={confirm} />
            <Button label="No Solicitar" onClick={cancel} type="cancel" />
          </>
        );
      case "solicitarMotivoCambioFechaFirma":
        return (
          <>
            <Button
              label={labelConfirm}
              onClick={confirmMotivoCambioFechaPrevista}
            />
            <Button label="Cancelar" onClick={cancel} type="cancel" />
          </>
        );
      default:
        return <Button label="Cancelar" onClick={cancel} type="cancel" />;
    }
  };

  return (
    <S.Wrapper onClick={cancel}>
      <S.Content onClick={(event) => event.stopPropagation()}>
        <S.Header>
          <p>{title}</p>
        </S.Header>
        <S.Body>
          {body()}
          <S.Buttons>{buttons()}</S.Buttons>
        </S.Body>
      </S.Content>
    </S.Wrapper>
  );
};

ModalConfirmacionFirma.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  labelConfirm: PropTypes.string,
  lists: PropTypes.object,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  message: PropTypes.string,
};
